module.exports = false;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_library.js
// module id = 85
// module chunks = 1 2 3